module.exports = __webpack_public_path__ + "img/H4.19fdbc38.png";